import InnerContainer, {
  InnerPaddingWrapper,
} from "components/atoms/inner/InnerContainer";
import styled from "styled-components";
import { noScrollBar } from "styles/commonStyles";
import { FLEX } from "styles/flex";
import * as mediaQuery from "components/MediaQuery";
import DefaultThumbnail from "components/atoms/image/DefaultThumbnail";

export const Container = styled(InnerPaddingWrapper)`
  position: relative;
`;

export const VideoContainer = styled(InnerContainer)`
  overflow: visible;
`;

export const VideoDiv = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 40px;

  > button {
    position: absolute;
    top: 40%;
    transform: translateY(-50%);
    height: 30px;

    > img {
      height: 100%;
    }
  }

  .button-left {
    left: -30px;
  }
  .button-right {
    right: -30px;
  }

  ${mediaQuery.isMobile} {
    margin-top: 30px;
  }
`;
export const VideoWrapper = styled.ul`
  ${mediaQuery.isDefault} {
    width: 100%;
    ${FLEX.FlexStartStart};
    gap: 20px;
    overflow: hidden;
    overflow-x: auto;
    padding: 16px 0;

    ${noScrollBar};
  }
`;

export const VideoItem = styled.li`
  cursor: pointer;
  min-width: 18%;
  max-width: 18%;

  * {
    white-space: normal;
  }
  .title {
    padding: 14px 0 8px;
  }

  ${mediaQuery.isTablet} {
    min-width: 33.33%;
    max-width: 33.33%;
  }

  ${mediaQuery.isMobile} {
    padding-bottom: 40px;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
`;

export const VideoThumbnail = styled(DefaultThumbnail)`
  img {
    object-fit: cover;
  }
  /* width: 100%;
  position: relative;

  img {
    overflow: hidden;
    object-fit: cover;
    width: 100%;
    height: auto;
  } */
`;

export const pdfThumbnail = styled(DefaultThumbnail)`
  ${FLEX.FlexCenterCenter};

  .icon-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding-top: 20px;
    ${FLEX.FlexCenterCenter};
    flex-direction: column;
    gap: 12px;
    background: ${({ theme }) => theme.COLORS.HELP.backgroundColor};
    border-radius: 2px;
    transition: all ease-out 0.1s;

    &:hover {
      background: ${({ theme }) => theme.COLORS.HELP.backgroundHoverColor};
    }

    .icon-pdf {
      font-size: 36px;
      color: ${({ theme }) => theme.COLORS.HELP.iconColor};
    }
  }

  .actions {
    display: flex;
    gap: 5px;

    & button svg {
      font-size: 24px;
      color: ${({ theme }) => theme.COLORS.HELP.iconColor};
      transition: color ease-out 0.1s;

      &:hover {
        color: ${({ theme }) => theme.COLORS.HELP.iconHoverColor};
      }
    }
  }
`;

export const TableListWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 48px;
  overflow-x: auto;

  table {
    min-width: 100%;
    width: max-content;
  }
  tr {
    display: grid;
    align-items: center;
    grid-template-columns: 20px 320px 1fr 90px;
    column-gap: 12px;

    height: 40px;
    margin-bottom: 4px;
    padding: 0 16px 0 12px;
    border-radius: 2px;
    background-color: ${({ theme }) => theme.COLORS.HELP.backgroundColor};
    transition: all ease-out 0.1s;
    cursor: pointer;

    &:hover {
      background: ${({ theme }) => theme.COLORS.HELP.backgroundHoverColor};
    }

    .file-type {
      position: relative;
      top: 1px;
      font-size: 20px;
      color: ${({ theme }) => theme.COLORS.HELP.iconColor};
    }

    .title {
      width: inherit;
      font-weight: 400;
      overflow: hidden;
      & > div {
        font-weight: unset;
        color: ${({ theme }) => theme.COLORS.HELP.titleColor};
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .description {
      width: inherit;
      overflow: hidden;
      & > div {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .actions {
    display: flex;
    justify-content: space-between;
    flex-direction: flex-end;

    & button svg {
      font-size: 20px;
      color: ${({ theme }) => theme.COLORS.HELP.iconColor};
      transition: color ease-out 0.1s;

      &:hover {
        color: ${({ theme }) => theme.COLORS.HELP.iconHoverColor};
      }
    }
  }
`;

export const ModalContainer = styled.div`
  ${FLEX.FlexCenterCenter};
  width: 100vw;
  height: 100vh;

  .close-button {
    position: absolute;
    top: 50px;
    right: 50px;
    width: 15px;

    img {
      width: 100%;
    }
  }
`;

export const VideoPlay = styled.div`
  aspect-ratio: 16/9;
  width: 100%;
  ${mediaQuery.isDefault} {
    max-width: 70vw;
    max-height: 70vh;
  }
  iframe,
  #player,
  > div {
    width: 100% !important;
    height: auto !important;
    aspect-ratio: 16/9 !important;
  }
`;
